import { connect } from 'react-redux';

import {
  selectFreeTrialDuration,
  selectNoTrial,
} from 'src/common/state/me/me-selectors';
import type { RootState } from 'src/redux';

import { DueTodayComponent } from './due-today-component';

const mapStateToProps = (state: RootState) => ({
  noTrial: selectNoTrial(state),
  trialPeriod: selectFreeTrialDuration(state),
});

export default connect(mapStateToProps)(DueTodayComponent);
